import _memoize from 'lodash/memoize';
import { FULL_HD, HD } from '@bedrock-rdk/constants';
import { TERTIARY, makeThemeColor } from '@tornado-rdk/theme';
import { SCREEN_HEIGHT, SCREEN_WIDTH } from '../../tornado/utils/sizes';
import { cacheResolver, makeDefaultStylingContext } from '../../tornado/utils/style';
import { WIDTH as SIDEBAR_WIDTH } from '../../sidenav/sidenav.constants';

export const defaultContext = makeDefaultStylingContext();

export const GRID_MARGIN_TOP = {
  [HD]: 112,
  [FULL_HD]: 256,
};

export const GRID_PADDING_LEFT = {
  [HD]: 40,
  [FULL_HD]: 40,
};

export const colors = {
  background: makeThemeColor(TERTIARY),
};

export const getInitialStyle = _memoize(
  ({ screenSize, colorMode } = defaultContext) => ({
    Background: {
      w: SCREEN_WIDTH[screenSize],
      h: SCREEN_HEIGHT[screenSize],
      color: colors.background[colorMode],
    },
    Grid: {
      y: GRID_MARGIN_TOP[screenSize],
      x: SIDEBAR_WIDTH[screenSize] + GRID_PADDING_LEFT[screenSize],
    },
  }),
  cacheResolver,
);
